var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParcelShopsbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "parcelShops_before_svg__Ebene_1",
    "data-name": "Ebene 1",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 1027.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parcelShops_before_svg__cls-11,.parcelShops_before_svg__cls-13,.parcelShops_before_svg__cls-14,.parcelShops_before_svg__cls-15,.parcelShops_before_svg__cls-16,.parcelShops_before_svg__cls-2,.parcelShops_before_svg__cls-20,.parcelShops_before_svg__cls-22,.parcelShops_before_svg__cls-23,.parcelShops_before_svg__cls-24,.parcelShops_before_svg__cls-25,.parcelShops_before_svg__cls-26,.parcelShops_before_svg__cls-28,.parcelShops_before_svg__cls-29,.parcelShops_before_svg__cls-3,.parcelShops_before_svg__cls-30,.parcelShops_before_svg__cls-31,.parcelShops_before_svg__cls-38,.parcelShops_before_svg__cls-4,.parcelShops_before_svg__cls-40,.parcelShops_before_svg__cls-42,.parcelShops_before_svg__cls-45,.parcelShops_before_svg__cls-46,.parcelShops_before_svg__cls-48{stroke:#343a50}.parcelShops_before_svg__cls-11,.parcelShops_before_svg__cls-13,.parcelShops_before_svg__cls-14,.parcelShops_before_svg__cls-16,.parcelShops_before_svg__cls-2,.parcelShops_before_svg__cls-20,.parcelShops_before_svg__cls-23,.parcelShops_before_svg__cls-24,.parcelShops_before_svg__cls-25,.parcelShops_before_svg__cls-28,.parcelShops_before_svg__cls-29,.parcelShops_before_svg__cls-3,.parcelShops_before_svg__cls-30,.parcelShops_before_svg__cls-31,.parcelShops_before_svg__cls-38,.parcelShops_before_svg__cls-4,.parcelShops_before_svg__cls-40,.parcelShops_before_svg__cls-48{stroke-miterlimit:10}.parcelShops_before_svg__cls-11,.parcelShops_before_svg__cls-15,.parcelShops_before_svg__cls-16,.parcelShops_before_svg__cls-2,.parcelShops_before_svg__cls-20,.parcelShops_before_svg__cls-22,.parcelShops_before_svg__cls-24,.parcelShops_before_svg__cls-3,.parcelShops_before_svg__cls-38,.parcelShops_before_svg__cls-4,.parcelShops_before_svg__cls-40,.parcelShops_before_svg__cls-42,.parcelShops_before_svg__cls-46,.parcelShops_before_svg__cls-48{stroke-width:2px}.parcelShops_before_svg__cls-13,.parcelShops_before_svg__cls-2{fill:#bc2a2b}.parcelShops_before_svg__cls-14,.parcelShops_before_svg__cls-3{fill:#c65d5d}.parcelShops_before_svg__cls-15,.parcelShops_before_svg__cls-4{fill:#aa2020}.parcelShops_before_svg__cls-8{fill:#7fc3ca}.parcelShops_before_svg__cls-6{fill:#eb9a6b}.parcelShops_before_svg__cls-7{fill:#343a50}.parcelShops_before_svg__cls-8{opacity:.56}.parcelShops_before_svg__cls-11{fill:#c6c6c4}.parcelShops_before_svg__cls-22,.parcelShops_before_svg__cls-23,.parcelShops_before_svg__cls-24{fill:#2a2118}.parcelShops_before_svg__cls-13,.parcelShops_before_svg__cls-14{stroke-width:2px}.parcelShops_before_svg__cls-15,.parcelShops_before_svg__cls-22,.parcelShops_before_svg__cls-26,.parcelShops_before_svg__cls-42,.parcelShops_before_svg__cls-45,.parcelShops_before_svg__cls-46{stroke-linecap:round;stroke-linejoin:round}.parcelShops_before_svg__cls-16{fill:#665948}.parcelShops_before_svg__cls-20{fill:#271b1d}.parcelShops_before_svg__cls-23{stroke-width:1.21px}.parcelShops_before_svg__cls-25{fill:#f0c100}.parcelShops_before_svg__cls-25,.parcelShops_before_svg__cls-26,.parcelShops_before_svg__cls-28,.parcelShops_before_svg__cls-29,.parcelShops_before_svg__cls-30,.parcelShops_before_svg__cls-31{stroke-width:3px}.parcelShops_before_svg__cls-26,.parcelShops_before_svg__cls-46{fill:#ffbb68}.parcelShops_before_svg__cls-27{fill:#c3c7ca}.parcelShops_before_svg__cls-28{fill:#b9c2df}.parcelShops_before_svg__cls-29{fill:#564d44}.parcelShops_before_svg__cls-30{fill:#756d6a}.parcelShops_before_svg__cls-31{fill:#938e8b}.parcelShops_before_svg__cls-38{fill:#ffaa86}.parcelShops_before_svg__cls-40{fill:#040a0a}.parcelShops_before_svg__cls-42,.parcelShops_before_svg__cls-45{fill:#ffccb5}.parcelShops_before_svg__cls-45{stroke-width:1.28px}.parcelShops_before_svg__cls-48{fill:#f7c12b}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Paket-Caf\\xE9_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Haus_hinten"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parcelShops_before_svg__Wand",
    fill: "#a8927b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "1258.98 865.89 -.99 865.89 -1 -53.08 1259.01 -53.09 1258.98 865.89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Dach"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1232.63,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1144.57,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.21,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 968.46,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 880.09,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 792.47,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.1,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 615.74,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 527.44,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.14,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.8,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.48,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.97,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.38,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-2",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.27,
    cy: 200.39,
    className: "parcelShops_before_svg__cls-3",
    rx: 47.83,
    ry: 62.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.71 200.39c0-32.84-19.94-59.66-45.7-61.87l.08 123.73c25.76-2.25 45.62-29.03 45.62-61.86z",
    className: "parcelShops_before_svg__cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.01 179.35 -.99 179.29 -1 -53.08 1259.01 -53.09 1259.01 179.35",
    className: "parcelShops_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.51,
    height: 326.3,
    x: 20.14,
    y: 380.74,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.63 707.04 109.63 554.78 20.15 554.78 20.15 533.08 109.63 533.08 109.63 380.73 131.28 380.73 131.28 533.08 220.67 533.08 220.67 554.78 131.28 554.78 131.28 707.04 109.63 707.04",
    className: "parcelShops_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28 381.72v152.35h89.39v19.71h-89.39V706h-19.65V553.78H21.15v-19.71h89.48V381.72h19.65m2-2h-23.65v152.36H19.16v23.69h89.47V708h23.65V555.77h89.39v-23.69h-89.39V379.73z",
    className: "parcelShops_before_svg__cls-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Haus_vorne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "parcelShops_before_svg__Fensterscheibe",
    points: "1195.34 728.16 1045.93 728.17 1045.93 551.71 1195.34 551.71 1195.34 728.16",
    className: "parcelShops_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1112.67 729.18 1112.67 647.79 1044.92 647.79 1044.92 632.1 1112.67 632.1 1112.67 550.71 1128.35 550.71 1128.35 632.1 1196.32 632.1 1196.32 647.79 1128.35 647.79 1128.35 729.18 1112.67 729.18",
    className: "parcelShops_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.35 551.7v81.4h68v13.69h-68v81.39h-13.68v-81.39h-67.75V633.1h67.75v-81.4h13.68m2-2h-17.68v81.4h-67.75v17.69h67.75v81.39h17.68v-81.39h68V631.1h-68v-81.4z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "parcelShops_before_svg__Wand-2",
    fill: "#e2ccb5",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M446.5 489.25v376.64h812.91V476.48zm231.43 239.93h-151.4V550.71h151.4zm518.41 0h-151.41V550.71h151.41z",
    "data-name": "Wand"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__T\\xFCr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.13,
    height: 312.62,
    x: 784.67,
    y: 503.23,
    fill: "#c62a2b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.55,
    y: 558.6,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849.18,
    y: 558.6,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902.19,
    y: 558.6,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.55,
    y: 631.15,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849.18,
    y: 631.15,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902.19,
    y: 631.15,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 796.36,
    y: 708.54,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 849,
    y: 708.54,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.19,
    height: 51.93,
    x: 902,
    y: 708.54,
    className: "parcelShops_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804.07,
    cy: 695.51,
    r: 7.7,
    fill: "#2a2118",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Dach-2",
    "data-name": "Dach"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1257.25,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1199.38,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1141.3,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1083.63,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1025.56,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 967.97,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 909.89,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 851.82,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 793.79,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 735.76,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.7,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.66,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.52,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.76,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-13",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.2,
    cy: 492.03,
    className: "parcelShops_before_svg__cls-14",
    rx: 31.44,
    ry: 40.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.54 492c0-14.55-6-27.3-15-34.52l-15 31.23v44c16.95-1.47 30-19.1 30-40.71z",
    className: "parcelShops_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1259.01 488.26 446.5 488.26 534.5 310.02 1259.02 310.02 1259.01 488.26",
    className: "parcelShops_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Fesnter"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "parcelShops_before_svg__Fensterscheibe-2",
    width: 149.4,
    height: 176.46,
    x: 527.53,
    y: 551.71,
    className: "parcelShops_before_svg__cls-8",
    "data-name": "Fensterscheibe"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.25 729.18 594.25 647.79 526.5 647.79 526.5 632.1 594.25 632.1 594.25 550.71 609.93 550.71 609.93 632.1 677.9 632.1 677.9 647.79 609.93 647.79 609.93 729.18 594.25 729.18",
    className: "parcelShops_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.93 551.71v81.39h68v13.7h-68v81.38h-13.67V646.8H527.5v-13.7h67.76v-81.39h13.67m2-2h-17.67v81.39H525.5v17.7h67.76v81.38h17.67V648.8h68v-17.7h-68v-81.39z",
    className: "parcelShops_before_svg__cls-7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.75 672.54l1-3.25c.77-1 3.44-1.48 4.82-.44l12.93 9.66-7.66 2.68z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.43 672l10.3 7.52-1.73 94.24-11.57-8.82v-91.4a1.88 1.88 0 013-1.54z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68 764.94h29.76l11.56 8.82-53.44 4.24 7.51-10.63a5.65 5.65 0 014.61-2.43z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.47 773.34v-91.9a4.5 4.5 0 014.5-4.5 4.49 4.49 0 014.5 4.5v98.69h-62.88a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 191.59,
    y: 780.13,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 195.66 832.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 246.32,
    y: 780.13,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 250.395 832.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 199.82,
    y: 780.13,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 203.895 825.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 237.86,
    y: 780.13,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 241.94 825.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 766.68H-19l-11.57 8.83 53.45 4.2-7.48-10.64a5.65 5.65 0 00-4.61-2.39z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30 775.08v-91.89a4.5 4.5 0 00-4.5-4.5 4.49 4.49 0 00-4.5 4.5v98.68h62.88a6.79 6.79 0 00-6.79-6.79z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 15.74,
    y: 781.87,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 7.5,
    y: 781.87,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.24 671.67l1-3.26c.78-1 3.44-1.47 4.82-.44l12.94 9.66-7.65 2.68z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.92 671.15l10.31 7.52-1.72 94.22-11.58-8.83v-91.39a1.88 1.88 0 012.99-1.52z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.18 764.06h29.75l11.58 8.83-53.46 4.19 7.52-10.63a5.62 5.62 0 014.61-2.39z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 772.46v-91.9a4.49 4.49 0 014.5-4.49 4.49 4.49 0 014.49 4.49v98.69h-62.91a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 686.08,
    y: 779.25,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 690.155 831.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 740.82,
    y: 779.25,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 744.89 831.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 694.32,
    y: 779.25,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 698.39 824.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 732.36,
    y: 779.25,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 736.435 824.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.22 673.42l-1-3.26c-.78-1-3.44-1.47-4.82-.44l-12.93 9.66 7.65 2.68z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.54 672.9l-10.31 7.52 1.77 94.22 11.58-8.83v-91.4a1.88 1.88 0 00-3.04-1.51z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.28 765.81h-29.75L464 774.64l53.46 4.19-7.52-10.63a5.62 5.62 0 00-4.66-2.39z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.49 774.21v-91.9a4.5 4.5 0 00-4.5-4.5 4.51 4.51 0 00-4.5 4.5V781h62.89a6.79 6.79 0 00-6.79-6.79z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 510.23,
    y: 781,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 455.49,
    y: 781,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 502,
    y: 781,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 463.95,
    y: 781,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.32 670.09l1-3.25c.77-1 3.44-1.48 4.82-.44l12.93 9.66-7.66 2.68z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 669.57l10.3 7.52-1.72 94.22-11.58-8.82v-91.4a1.88 1.88 0 013-1.52zM1209.25 762.49H1239l11.57 8.82-53.45 4.2 7.51-10.63a5.65 5.65 0 014.62-2.39z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 770.89V679a4.5 4.5 0 014.5-4.5 4.49 4.49 0 014.5 4.5v98.69h-62.88a6.79 6.79 0 016.79-6.79z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1196.16,
    y: 777.68,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 1200.23 829.695)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1250.89,
    y: 777.68,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 1254.97 829.695)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1204.39,
    y: 777.68,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 1208.465 822.675)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1242.44,
    y: 777.68,
    className: "parcelShops_before_svg__cls-16",
    transform: "rotate(-180 1246.51 822.675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.3 671.84l-1-3.26c-.78-1-3.45-1.47-4.83-.44l-12.93 9.66 7.66 2.69z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.62 671.32l-10.31 7.52 1.69 94.22 11.57-8.82v-91.4a1.88 1.88 0 00-2.95-1.52z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.36 764.24H985.6l-11.6 8.82 53.45 4.2-7.45-10.64a5.66 5.66 0 00-4.64-2.38z",
    className: "parcelShops_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.57 772.64v-91.9a4.49 4.49 0 00-4.5-4.5 4.5 4.5 0 00-4.5 4.5v98.68h62.88a6.78 6.78 0 00-6.79-6.78z",
    className: "parcelShops_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 1020.31,
    y: 779.42,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 104.04,
    x: 965.57,
    y: 779.42,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 1012.07,
    y: 779.42,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.15,
    height: 89.99,
    x: 974.03,
    y: 779.42,
    className: "parcelShops_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 91.92,
    x: -1,
    y: 936.99,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 938v89.93H0V938h1258m2-2H-2v93.93h1262V936z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Boden"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5714e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "-.99 894.06 1259.04 894.19 1258.98 865.89 -.99 865.89 -.99 894.06"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 46.59,
    x: -1,
    y: 890.46,
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 891.46v44.6H0v-44.6h1258m2-2H-2v48.6h1262v-48.6z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Schild"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.07 658.37c-1.6-4.32-25.08-7.75-53.83-7.75s-52.23 3.43-53.83 7.75h-.09v127.12h107.84V658.37z",
    className: "parcelShops_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.3,
    height: 115.87,
    x: 320.09,
    y: 664.22,
    fill: "#d9dbda",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 80.4,
    x: 315.32,
    y: 785.49,
    className: "parcelShops_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 80.4,
    x: 418.39,
    y: 785.49,
    className: "parcelShops_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.77,
    height: 59.42,
    x: 366.86,
    y: 785.49,
    className: "parcelShops_before_svg__cls-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Tische"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Tische-2",
    "data-name": "Tische"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1198.43 745.11l-155.43-.54 4.77-8.85a6 6 0 015.28-3.15h132.57a6 6 0 014.72 2.29z",
    className: "parcelShops_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1120.45,
    cy: 874.59,
    className: "parcelShops_before_svg__cls-23",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 1042.23,
    y: 739.49,
    className: "parcelShops_before_svg__cls-24",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 1114.89,
    y: 754.48,
    className: "parcelShops_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "679.89 745.11 524.51 744.57 530.98 732.57 670.04 732.57 679.89 745.11",
    className: "parcelShops_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 524.01,
    y: 739.95,
    className: "parcelShops_before_svg__cls-24",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.23,
    cy: 875.06,
    className: "parcelShops_before_svg__cls-23",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 596.67,
    y: 754.95,
    className: "parcelShops_before_svg__cls-24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.26 745.18l-155.38-.54 4.77-8.85a6 6 0 015.28-3.15H167.5a6 6 0 014.71 2.29z",
    className: "parcelShops_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156.43,
    height: 14.93,
    x: 23.83,
    y: 738.91,
    className: "parcelShops_before_svg__cls-24",
    rx: 7.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 874.01,
    className: "parcelShops_before_svg__cls-23",
    rx: 43.96,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.12,
    height: 120.11,
    x: 96.49,
    y: 753.9,
    className: "parcelShops_before_svg__cls-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Postauto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.81 576H627.3a31 31 0 0131 31v294.3H176.88V654a77.93 77.93 0 0177.93-78z",
    className: "parcelShops_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Oaket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "491.24 802.05 406.72 830.21 406.72 719.06 491.24 690.81 491.24 802.05",
    className: "parcelShops_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.21 800.43 406.72 830.21 406.72 719.06 320.6 690.81 321.21 800.43",
    className: "parcelShops_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.72 661.95 491.24 690.81 406.72 719.19 320.6 690.81 406.72 661.95",
    className: "parcelShops_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.21 743.56a1.49 1.49 0 01-.86-.27 1.5 1.5 0 01-.64-1.23V708a1.49 1.49 0 011-1.42l21.8-7.33a1.59 1.59 0 01.48-.07 1.43 1.43 0 01.87.28 1.48 1.48 0 01.63 1.22V734a1.5 1.5 0 01-1 1.41l-21.8 8a1.58 1.58 0 01-.48.15z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 700.63V734l-21.8 8v-34l21.8-7.32m0-3a3.2 3.2 0 00-1 .15l-21.8 7.32a3 3 0 00-2 2.85v34.11a3 3 0 001.28 2.46 3 3 0 001.72.54 3.12 3.12 0 001-.18l21.8-8a3 3 0 002-2.82v-33.48a3 3 0 00-3-3z",
    className: "parcelShops_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16 710a1.48 1.48 0 01-.51-.09l-81-29.56a1.5 1.5 0 010-2.83l24.54-8.23a1.51 1.51 0 01.48-.08 1.49 1.49 0 01.51.1l81.3 30a1.5 1.5 0 01-.07 2.84l-24.85 7.82a1.69 1.69 0 01-.4.03z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.72 670.66l81.29 30-24.85 7.82-81-29.56 24.54-8.23m0-3a3.12 3.12 0 00-1 .16L355.23 676a3 3 0 00-.08 5.67l81 29.56a3.06 3.06 0 001 .18 3 3 0 00.9-.14l24.85-7.82a3 3 0 00.14-5.68l-81.3-30a3 3 0 00-1-.19z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 618.08,
    height: 44.92,
    x: 164.1,
    y: 901.3,
    className: "parcelShops_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.5,
    height: 39.5,
    x: 940.37,
    y: 901.3,
    className: "parcelShops_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 781.3c-43.56-12.7-51.54-18.3-51.54-18.3-15.28-10.74-24-25.59-29.31-34.69A92.64 92.64 0 00829.09 707a96.16 96.16 0 00-12.57-15.57A93.78 93.78 0 00750 663.92h-91.66V901.3h311.59v-54.82A67.52 67.52 0 00920 781.3z",
    className: "parcelShops_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__R\\xE4der"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 303.39,
    cy: 927.18,
    r: 72.35,
    className: "parcelShops_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.82,
    cy: 929.4,
    r: 34.09,
    className: "parcelShops_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.82,
    cy: 929.4,
    r: 12.78,
    className: "parcelShops_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.94,
    cy: 927.18,
    r: 72.35,
    className: "parcelShops_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.38,
    cy: 929.4,
    r: 34.09,
    className: "parcelShops_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 863.38,
    cy: 929.4,
    r: 12.78,
    className: "parcelShops_before_svg__cls-31"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#cea705",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M829.29 842.43v-70.77a89.85 89.85 0 00-89.85-89.85h-68.88v205.82H779.3a90.55 90.55 0 0149.99-45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3e0ff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M682.81 695.13h61.13A73.09 73.09 0 01817 768.22v3.61h0-134.19 0v-76.7h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6dc6e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M971.35 840.69h4.5a6.15 6.15 0 016.15 6.15v19.71a6.15 6.15 0 01-6.15 6.15h-4.5 0v-32-.01z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M149 895.21a25.16 25.16 0 00-38.52-31 29.52 29.52 0 00-7.87 1.29 31.77 31.77 0 00-17.18-43.46l.18-.57c.79 0 1.59.09 2.4.09a34.87 34.87 0 0026.1-58 44.54 44.54 0 00-3.11-81.09c19.72-9.62 32.88-26.88 32.88-46.58 0-11.93-4.84-23-13-32 19.46-9.66 32.4-26.79 32.4-46.33 0-26.75-24.26-49-56.31-53.73a44.59 44.59 0 004.34-19.1c0-30.19-30.91-54.67-69-54.67s-69 24.48-69 54.67c0 13.32 6 25.52 16 35-30.1 5.89-52.42 27.41-52.42 53.06 0 28.92 28.36 52.58 64.25 54.53a51.44 51.44 0 00-3.17 89c-14.75 5.93-24.66 16.94-24.66 29.56 0 18.89 22.22 34.2 49.64 34.2h1.46a53.36 53.36 0 00-6.1 25.16c0 19.88 10.2 36.71 24.28 42.44a32.55 32.55 0 00-.25 4 31.76 31.76 0 0042.16 30 29.4 29.4 0 0041.5 37.43 19.39 19.39 0 1023-23.9z",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Postbote"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f2e38",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M889.58 992.57c-1.21 1.5-1.72 1-1.85 7-.1 4.43-5.63 9.78-5.41 12.45h57.28a7.51 7.51 0 000-3.22c-1.21-5.1-8.42-7-12.52-8.15-4.6-1.24-5.09-.48-8-1.89-4.08-2-4.45-4.11-7.86-6.26-2.51-1.57-3.52-1.18-13-2.08-10.97-1.01-6.97.07-8.64 2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e4354",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M886.57 994.45c-1.22 1.27-4.12 7.19-4.26 12.31a84 84 0 000 9.07h57.29a5.42 5.42 0 000-2.73c-1.21-4.32-8.42-6-12.52-6.9-4.6-1.05-5.09-.4-8-1.6-4.08-1.68-6.75-1.73-10.16-3.55-2.51-1.33-1.22-2.75-10.7-3.51-10.97-.88-9.98-4.85-11.65-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.64 975.82a29.15 29.15 0 01-.65 11.87c-.51 1.84-1.25 3.67-.32 5.13 1.13 1.77 4 1.88 5.46 1.93s3.75.13 4.81-1.28c.91-1.21.46-2.94.32-3.53-.63-2.73-.91-7.54.32-16.69M887.61 981.17a29 29 0 01-.64 11.88c-.51 1.83-1.25 3.67-.32 5.13 1.13 1.77 4 1.87 5.46 1.93s3.75.13 4.81-1.29c.9-1.2.46-2.93.32-3.53-.64-2.72-.91-7.53.32-16.68",
    className: "parcelShops_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M913.25 866.46c.31 13.48.39 24.64.41 32.57.07 27.61.11 41.41-.5 48.47a159.32 159.32 0 00-.51 25.75c.33 5.13.86 9.34 1.27 12.12L899.73 984l-4.34-46.86 6.66-30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.19 848.17q.4 13.17 1 26.47 2.33 56.79 6.74 111.19l21.4-.21c-.08-.76-.2-1.87-.32-3.21-1.91-20.18-.27-34.45.16-43.24.64-13.32 1.37-22.78 2.18-30.78.61-6 2.17-17.87 3.05-24.85 1.14-9.09 1.34-10.46 1.6-13.39a162.07 162.07 0 00.33-24.39z",
    className: "parcelShops_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 853.46h1.53c-.5-13.18-.45-24-.32-31.45.24-13.34.86-20.55-.49-32.73a109.23 109.23 0 00-4-20c-3-9.83-6-14.89-7.86-17.49-1.57-2.19-3.21-4-3.21-4-2.7-3-3.41-2.94-6.58-6.1-3.32-3.32-3.82-4.66-5.29-4.65-1.73 0-3 1.86-4.49 4.17-5.58 8.52-8.37 12.79-8.83 13.8a61.5 61.5 0 00-4.33 13.79c-1.7 9.13-.34 13.53-.32 28.56 0 5.67-.18 10.24-.32 13l.65 42.2c.56 0 1.46.07 2.56.16a80.6 80.6 0 0110.11 1.44c4.07.81 13.36 2.64 20.86.8a44.15 44.15 0 0110.33-1.5z",
    className: "parcelShops_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M884.72 731.52a4.48 4.48 0 01-2.4-.32c-2-.9-2.58-3.25-3.05-4.65-1.38-4.12-2.54-3.1-7.22-11.07-2.22-3.77-3.33-5.66-4-7.7-2.49-7.39-.25-16.35 4.33-22.63 5.89-8.08 14.54-10.19 17.49-10.91 5.91-1.44 11-.86 19.89.16a116.55 116.55 0 0111.55 1.93 17.31 17.31 0 00-3.53 1.28 17.54 17.54 0 00-4.17 2.89l11.55.48a10.42 10.42 0 010 2.09c-.5 5.26-4.72 8.59-5.45 9.14-4.69 3.57-7.51.76-11.07 3.37-5.26 3.87-.41 11-6.1 21.34-2.07 3.77-4.86 6.2-10.43 11.07a13.47 13.47 0 01-7.39 3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.19 729.92a78.69 78.69 0 007.63 4l.39.18c3.6 1.61 6.83 2.83 10.27 2.24a4.68 4.68 0 002.08-1 8.11 8.11 0 002.89-4 21.64 21.64 0 001-10.51c0-.07-.15-.41 0-.57s.29-.08.37-.07a6.77 6.77 0 002.64-.18 2 2 0 001-.91 2.17 2.17 0 00.06-1.5 5 5 0 00-1-1.93 7.82 7.82 0 01-1-1.64s0-.17-.12-.37-.14-.38-.15-.41a12.06 12.06 0 01-.46-1.8 18.73 18.73 0 01-.4-3.77 17.8 17.8 0 01.64-3.61 18.83 18.83 0 00.4-7.14A8.37 8.37 0 00919 693a8.21 8.21 0 00-5.06-2.88c-.82-.18-5.18-1-7.86 1.6a8.19 8.19 0 00-1.76 3.21c-1.68 4.26-.75 5.52-2.09 8.82-1 2.36-3 5.6-5.29 5.62a2.52 2.52 0 01-1.61-.48c-.73-.59-.59-1.38-1.44-3.37a3.77 3.77 0 00-.81-1.44 3.42 3.42 0 00-3.85 0 4.77 4.77 0 00-1.76 3.2 11.46 11.46 0 00.32 6.1c.63 2 1.33 2.47 1.6 4.49a9.93 9.93 0 010 2.73 38.15 38.15 0 01-2.88 9.47c-2.3 5.8-3.66 9.36-2.09 11.23.33.39.54.41 2 1.08 3.83 1.82 4 2.53 7.58 4.33 1.31.67 6.39 3.26 7.1 2.29.2-.28 0-.72-.36-1.44a19.21 19.21 0 01-1.33-5.9c-.44-3.67.54-6.37 1-6.38.08 0 2.79.33 3.06.3l1.51.09s-.62 0 1.12-.06",
    className: "parcelShops_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.28,
    d: "M911.83 703.86a3.75 3.75 0 012.11-1.32 3.89 3.89 0 013.16.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 914.46,
    cy: 708.61,
    fill: "#fff",
    rx: 2.64,
    ry: 1.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 914.93,
    cy: 709.18,
    className: "parcelShops_before_svg__cls-7",
    rx: 0.92,
    ry: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.84 725.5a12.85 12.85 0 012.31-.12 13.23 13.23 0 016 1.81M890.82 707.86a3.22 3.22 0 011.2 1.2 3.94 3.94 0 01-.12 3.61",
    className: "parcelShops_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.88 812.07a6.62 6.62 0 01-3.1.49 5.86 5.86 0 01-1-.17c-2.83-.73-11.85-1.65-23.1-4.18q-2.76-.62-5.46-1.28s-.19-2.08-.32-3.21c-.25-2.32-.56-4-.64-4.49-.31-1.9-.64-6.57-.64-18.93l-15.08 1.28c.11 12.57-.11 20.27-.64 24.07a15.07 15.07 0 00.32 6.41 16.89 16.89 0 001.92 4.18c2.34 3.55 21.74 6.58 48.46 6.74l.93.49c4.5 2.45 5 3.26 7.16 4.24 1.77.79 4.13 1.85 6.68 1a7.24 7.24 0 003.09-2c3.32-3.37 3.38-8.19 3.34-9.77",
    className: "parcelShops_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.31 758.87q-.06 4.53 0 9.19c.16 12.92 1 25.19 2.29 36.77l26 5.1v16.34c-2.2-.42-5.47-1-9.45-1.53-7.34-1-11.26-1.06-15.83-1.53-10.81-1.13-18.33-3.07-20.7-5.28-1.52-1.43-1.17-11.57-1.17-11.57-.09-4.77.17-10.2.42-15.58a217.47 217.47 0 00-.51-28.59",
    className: "parcelShops_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Oaket-2",
    "data-name": "Oaket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1017.23 811.79 967.35 820.72 967.35 785.48 1017.23 776.53 1017.23 811.79",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "916.9 811.28 967.35 820.72 967.35 785.48 916.53 776.53 916.9 811.28",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "967.35 767.38 1017.23 776.53 967.35 785.52 916.53 776.53 967.35 767.38",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.12 793.77a1.05 1.05 0 01-.64-.22 1 1 0 01-.36-.78V782a1 1 0 01.82-1l12.87-2.32h.17a1 1 0 011 1v10.59a1 1 0 01-.8 1l-12.87 2.54a.62.62 0 01-.19-.04z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 779.64v10.59l-12.86 2.54V782l12.86-2.32m0-2a2.07 2.07 0 00-.35 0L986.76 780a2 2 0 00-1.64 2v10.81a2 2 0 00.73 1.55 2 2 0 001.27.45h.39l12.86-2.55a2 2 0 001.61-2v-10.62a2 2 0 00-2-2z",
    className: "parcelShops_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.32 783.12h-.19l-47.79-9.37a1 1 0 010-2l14.48-2.61h.18a.62.62 0 01.19 0l48 9.5a1 1 0 01.8 1 1 1 0 01-.83 1l-14.66 2.48z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952 770.14l48 9.5-14.66 2.48-47.79-9.37 14.45-2.61m0-2a2 2 0 00-.35 0l-14.48 2.61a2 2 0 000 3.93l47.79 9.37a2.33 2.33 0 00.38 0h.33l14.67-2.48a2 2 0 000-3.93l-48-9.5a1.72 1.72 0 00-.39 0z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Oaket-3",
    "data-name": "Oaket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "995.65 776.13 962.1 785.47 962.1 748.59 995.65 739.22 995.65 776.13",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "928.17 775.59 962.1 785.47 962.1 748.59 927.92 739.22 928.17 775.59",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "962.1 729.65 995.65 739.22 962.1 748.64 927.92 739.22 962.1 729.65",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.39 757.23a1 1 0 01-.59-.2 1 1 0 01-.41-.8v-11.32a1 1 0 01.73-1l8.66-2.42a.8.8 0 01.27 0 1 1 0 01.6.2 1 1 0 01.4.8v11.08a1 1 0 01-.71 1l-8.65 2.66a1 1 0 01-.3 0z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.05 742.48v11.08l-8.66 2.67v-11.32l8.66-2.43m0-2a1.9 1.9 0 00-.54.07l-8.66 2.45a2 2 0 00-1.46 1.93v11.32a2 2 0 002.59 1.91l8.65-2.67a2 2 0 001.42-1.91v-11.1a2 2 0 00-2-2z",
    className: "parcelShops_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.18 746.07a1 1 0 01-.29 0l-32.14-9.81a1 1 0 010-1.92l9.74-2.73a1.24 1.24 0 01.27 0 1 1 0 01.3 0l32.26 9.94a1 1 0 010 1.92l-9.86 2.6a1.09 1.09 0 01-.28 0z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.78 732.54l32.27 9.94-9.87 2.59-32.18-9.8 9.74-2.73m0-2a2 2 0 00-.54.07l-9.74 2.73a2 2 0 000 3.84L973.6 747a2.32 2.32 0 00.58.08 2.1 2.1 0 00.51-.06l9.86-2.6a2 2 0 00.08-3.84l-32.26-9.94a2 2 0 00-.59-.09z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.03,
    d: "M904.76 704.57c-.82 0-.85 3-2.65 7.94a4 4 0 00-.23 2.25 3.12 3.12 0 002 2.5c1.58.3 3.34-1.83 3.58-3.74.11-.86-.13-1.38-.62-2.8-1.61-4.72-1.51-6.12-2.08-6.15z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parcelShops_before_svg__Oaket-4",
    "data-name": "Oaket"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "991.11 739.45 968.97 745.62 968.97 721.28 991.11 715.09 991.11 739.45",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "946.57 739.1 968.97 745.62 968.97 721.28 946.41 715.09 946.57 739.1",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "968.97 708.77 991.11 715.09 968.97 721.31 946.41 715.09 968.97 708.77",
    className: "parcelShops_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.74 727.31a1 1 0 01-.59-.19 1 1 0 01-.41-.81v-7.47a1 1 0 01.73-1l5.71-1.6a.86.86 0 01.28 0 1 1 0 01.6.2 1 1 0 01.4.8v7.31a1 1 0 01-.71 1l-5.75 1.72a1 1 0 01-.26.04z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.45 717.24v7.31l-5.71 1.76v-7.47l5.71-1.6m0-2a2 2 0 00-.54.07l-5.71 1.61a2 2 0 00-1.46 1.92v7.47a2 2 0 00.82 1.61 2 2 0 001.77.31l5.71-1.77a2 2 0 001.41-1.91v-7.31a2 2 0 00-2-2z",
    className: "parcelShops_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977 720a1 1 0 01-.3 0l-21.21-6.47a1 1 0 01-.71-1 1 1 0 01.73-1l6.43-1.8a.84.84 0 01.27 0 .92.92 0 01.29 0l21.3 6.56a1 1 0 010 1.93l-6.51 1.71a1.07 1.07 0 01-.29.07z",
    className: "parcelShops_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.16 710.68l21.29 6.56L977 719l-21.22-6.47 6.43-1.8m0-2a2 2 0 00-.54.07l-6.43 1.8a2 2 0 000 3.84l21.21 6.48a2.33 2.33 0 00.59.08 2.07 2.07 0 00.5-.06l6.51-1.72a2 2 0 00.08-3.84l-21.29-6.56a2 2 0 00-.59-.09z",
    className: "parcelShops_before_svg__cls-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M885.81 820.4q-.37 9.12-.53 18.64-.12 7.89-.09 15.52l12.62 1.11q0-16.44-.08-32.89l-4.53-.72zM882.56 741.34q1.37-3.75 2.72-7.49L900.6 741l2.73 10.89z",
    className: "parcelShops_before_svg__cls-48"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelShopsbefore);
export default __webpack_public_path__ + "static/media/parcelShops.before.29bcc85d.svg";
export { ForwardRef as ReactComponent };